import { DealerJackAction } from "./DealerJackReducer";
import {
  DealerJackProtocol,
  BlackjackProtocolData,
} from "./DealerJackProtocol";
import SocketService from "network/SocketService";
import UserSession from "network/UserSession";

export class DealerJackSocketService {
  private dispatch: React.Dispatch<DealerJackAction>;
  private socket = SocketService.getInstance();

  constructor(dispatch: React.Dispatch<DealerJackAction>) {
    this.dispatch = dispatch;
  }

  public initializeListeners() {
    // 게임 시작
    this.socket.on(
      DealerJackProtocol.GAME_START,
      (data: BlackjackProtocolData[typeof DealerJackProtocol.GAME_START]) => {
        this.dispatch({
          type: "SOCKET_GAME_START",
          payload: data,
        });
      }
    );

    // 라운드 시작
    this.socket.on(
      DealerJackProtocol.ROUND_START,
      (data: BlackjackProtocolData[typeof DealerJackProtocol.ROUND_START]) => {
        this.dispatch({
          type: "SOCKET_ROUND_START",
          payload: data,
        });
      }
    );

    // 베팅 결과
    this.socket.on(
      DealerJackProtocol.BET_PLACED,
      (data: BlackjackProtocolData[typeof DealerJackProtocol.BET_PLACED]) => {
        this.dispatch({
          type: "SOCKET_BET_PLACED",
          payload: data,
        });
      }
    );

    // 베팅 시간 종료
    this.socket.on(
      DealerJackProtocol.BETTING_TIME_END,
      (
        data: BlackjackProtocolData[typeof DealerJackProtocol.BETTING_TIME_END]
      ) => {
        this.dispatch({
          type: "SOCKET_BETTING_TIME_END",
          payload: data,
        });
      }
    );

    // 카드 배분
    this.socket.on(
      DealerJackProtocol.CARDS_DEALT,
      (data: BlackjackProtocolData[typeof DealerJackProtocol.CARDS_DEALT]) => {
        this.dispatch({
          type: "SOCKET_CARDS_DEALT",
          payload: data,
        });
      }
    );

    // 플레이어 턴
    this.socket.on(
      DealerJackProtocol.PLAYER_TURN,
      (data: BlackjackProtocolData[typeof DealerJackProtocol.PLAYER_TURN]) => {
        this.dispatch({
          type: "SOCKET_PLAYER_TURN",
          payload: data,
        });
      }
    );

    // 카드 히트
    this.socket.on(
      DealerJackProtocol.CARD_HIT,
      (data: BlackjackProtocolData[typeof DealerJackProtocol.CARD_HIT]) => {
        this.dispatch({
          type: "SOCKET_CARD_HIT",
          payload: data,
        });
      }
    );

    // 플레이어 스탠드
    this.socket.on(
      DealerJackProtocol.PLAYER_STAND,
      (data: BlackjackProtocolData[typeof DealerJackProtocol.PLAYER_STAND]) => {
        this.dispatch({
          type: "SOCKET_PLAYER_STAND",
          payload: data,
        });
      }
    );

    // 플레이어 액션 응답 (서버에서 개인에게만 전송)
    this.socket.on(
      DealerJackProtocol.PLAYER_ACTION,
      (data: BlackjackProtocolData[typeof DealerJackProtocol.PLAYER_ACTION]) => {
        console.log("Received PLAYER_ACTION from server:", data);
        this.dispatch({
          type: "SOCKET_PLAYER_ACTION",
          payload: data,
        });
      }
    );

    // 플레이어 액션 완료 (모든 플레이어에게 브로드캐스트)
    this.socket.on(
      DealerJackProtocol.PLAYER_ACTION_COMPLETED,
      (data: BlackjackProtocolData[typeof DealerJackProtocol.PLAYER_ACTION_COMPLETED]) => {
        console.log("Received PLAYER_ACTION_COMPLETED from server:", data);
        this.dispatch({
          type: "SOCKET_PLAYER_ACTION_COMPLETED",
          payload: data,
        });
      }
    );

    // 딜러 턴
    this.socket.on(
      DealerJackProtocol.DEALER_TURN,
      (data: BlackjackProtocolData[typeof DealerJackProtocol.DEALER_TURN]) => {
        this.dispatch({
          type: "SOCKET_DEALER_TURN",
          payload: data,
        });
      }
    );

    // 라운드 결과
    this.socket.on(
      DealerJackProtocol.ROUND_RESULTS,
      (
        data: BlackjackProtocolData[typeof DealerJackProtocol.ROUND_RESULTS]
      ) => {
        this.dispatch({
          type: "SOCKET_ROUND_RESULTS",
          payload: data,
        });
      }
    );

    // 게임 종료
    this.socket.on(
      DealerJackProtocol.GAME_END,
      (data: BlackjackProtocolData[typeof DealerJackProtocol.GAME_END]) => {
        this.dispatch({
          type: "SOCKET_GAME_END",
          payload: data,
        });
      }
    );

    // 플레이어 제외 (파산)
    this.socket.on(
      DealerJackProtocol.PLAYER_ELIMINATED,
      (data: BlackjackProtocolData[typeof DealerJackProtocol.PLAYER_ELIMINATED]) => {
        console.log("Players eliminated:", data);
        this.dispatch({
          type: "SOCKET_PLAYER_ELIMINATED",
          payload: data,
        });

        // 파산 처리 (알림 제거)
      }
    );

    // 에러 처리
    this.socket.on(
      DealerJackProtocol.ERROR,
      (error: BlackjackProtocolData[typeof DealerJackProtocol.ERROR]) => {
        console.error("DealerJack Socket Error:", error);

        // 에러 코드별 처리
        if (error.code === "MIN_BET_REQUIRED") {
          alert(`최소 베팅액은 ${error.minBet}칩입니다.`);
        } else if (error.code === "ALL_IN_REQUIRED") {
          alert("칩이 부족합니다. 올인만 가능합니다.");
        } else {
          // 기타 에러 처리
          alert(error.message || "게임 오류가 발생했습니다.");
        }
      }
    );
  }

  public cleanup() {
    this.socket.off(DealerJackProtocol.GAME_START);
    this.socket.off(DealerJackProtocol.ROUND_START);
    this.socket.off(DealerJackProtocol.BET_PLACED);
    this.socket.off(DealerJackProtocol.BETTING_TIME_END);
    this.socket.off(DealerJackProtocol.CARDS_DEALT);
    this.socket.off(DealerJackProtocol.PLAYER_TURN);
    this.socket.off(DealerJackProtocol.CARD_HIT);
    this.socket.off(DealerJackProtocol.PLAYER_STAND);
    this.socket.off(DealerJackProtocol.PLAYER_ACTION);
    this.socket.off(DealerJackProtocol.PLAYER_ACTION_COMPLETED);
    this.socket.off(DealerJackProtocol.DEALER_TURN);
    this.socket.off(DealerJackProtocol.ROUND_RESULTS);
    this.socket.off(DealerJackProtocol.GAME_END);
    this.socket.off(DealerJackProtocol.PLAYER_ELIMINATED);
    this.socket.off(DealerJackProtocol.ERROR);
  }

  // 베팅 요청
  public placeBet(amount: number) {
    const userId = UserSession.getInstance().getUserId();
    this.socket.emit(DealerJackProtocol.BET_REQUEST, {
      playerId: userId,
      amount: amount,
    });
  }

  // 히트 요청 (카드 한 장 더 받기)
  public requestHit() {
    const userId = UserSession.getInstance().getUserId();
    console.log("DealerJackSocketService.requestHit() called", {
      userId,
      protocol: DealerJackProtocol.HIT_REQUEST,
      socketConnected: this.socket.isConnected(),
    });

    this.socket.emit(DealerJackProtocol.HIT_REQUEST, {
      playerId: userId,
    });

    console.log("HIT request emitted to server");
  }

  // 스탠드 요청 (카드 받기 중단)
  public requestStand() {
    const userId = UserSession.getInstance().getUserId();
    this.socket.emit(DealerJackProtocol.STAND_REQUEST, {
      playerId: userId,
    });
  }

  // 더블다운 요청 (베팅 2배, 카드 1장 받고 스탠드)
  public requestDoubleDown() {
    const userId = UserSession.getInstance().getUserId();
    console.log("DealerJackSocketService.requestDoubleDown() called", {
      userId,
      protocol: DealerJackProtocol.DOUBLE_DOWN_REQUEST,
      socketConnected: this.socket.isConnected(),
    });

    this.socket.emit(DealerJackProtocol.DOUBLE_DOWN_REQUEST, {
      playerId: userId,
    });

    console.log("DOUBLE_DOWN request emitted to server");
  }

  // 항복 요청 (베팅의 50% 돌려받고 포기)
  public requestSurrender() {
    const userId = UserSession.getInstance().getUserId();
    console.log("DealerJackSocketService.requestSurrender() called", {
      userId,
      protocol: DealerJackProtocol.SURRENDER_REQUEST,
      socketConnected: this.socket.isConnected(),
    });

    this.socket.emit(DealerJackProtocol.SURRENDER_REQUEST, {
      playerId: userId,
    });

    console.log("SURRENDER request emitted to server");
  }

  // 결과 스킵 요청
  public requestSkipResults() {
    const userId = UserSession.getInstance().getUserId();
    this.socket.emit(DealerJackProtocol.SKIP_RESULTS_REQUEST, {
      playerId: userId,
    });
  }

  // 커스텀 이벤트 리스너 추가
  public addCustomListener(event: string, callback: (data: any) => void) {
    this.socket.on(event, callback);
  }

  // 커스텀 이벤트 리스너 제거
  public removeCustomListener(event: string, callback: (data: any) => void) {
    this.socket.off(event, callback);
  }
}

// 하위 호환성을 위한 alias
export const BlackjackSocketService = DealerJackSocketService;
